<template>
  <div class="service-listing result-page">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!--loader-->
                <div class="generic-loader" v-show="isAjaxLoading">
                    <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
                </div>

                <div v-for="(item, index) in filteredData" :key="index" class="search-block">
                    <div class="search-card" v-if="item.Title && item.Url">
                        <h2 class="search-card-title">{{ item.Title }}</h2>
                        <!--<p class="search-card-description">{{ item.Description }}</p>-->
                        <div class="search-card-read-more">
                            <span class="read-more" @click="getLinkId(item.Id, item.Url)">
                                <span>{{ readMore }}</span>
                                <i class="icon-next"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="search-no-result" v-if="resultNoData">
                    <i class="icon-Icon-error"></i>

                    <div class="generic-error-message">
                        <p class="message-text">
                            <span>{{ Sorry }}</span>
                            {{ NoDataFound }}
                        </p>
                    </div>
                </div>
                

            </div>

        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";


//let baseUrl = document.location.origin;
//let apiUrl = baseUrl + "";

export default {
  props: {
    NoDataFound: String,
    readMore: String,
    Sorry: String,
    AdminUrl: String
  },
  data() {
    return {
      info: null,
      data: [],
      isAjaxLoading: true,
      filteredData: [],
      dataArray: [],
      resultNoData: false,
      pageNumber: 1,
      query: '',
      lang: ''
    };
  },
  methods: {
    getSearchResult() {
        this.dataArray = [];
        this.isAjaxLoading = true;
        //this.resultNoData = false;
        axios
            .post(`${this.AdminUrl}/Umbraco/Surface/Search/Get?pageNumber=${this.pageNumber}&q=${this.query}&culture=${this.lang}`)
            .then(res => {
                this.isAjaxLoading = false;
                this.dataArray = res.data;

                if (this.dataArray.length != 0) {
                    this.slice();
                } else {
                    if (this.filteredData.length != 0) {
                        if (this.filteredData.length == 1 && !this.filteredData[0].Title) {
                            this.resultNoData = true;
                        } else {
                            this.resultNoData = false;
                        }
                    } else {
                        this.resultNoData = true;
                    }
                }
            }).catch(() => {

            })
    },
    getLinkId(id, url) {
        if (url.substr(-1) === '/') {
            url = url.substr(0, url.length - 1);
        }
        window.location.href = `${url}?id=${id}`;
    },
    slice() {
        this.filteredData = this.filteredData.concat(this.dataArray);
        if (this.filteredData.length == 1 && !this.filteredData[0].Title) {
            this.resultNoData = true;
        } else {
            this.resultNoData = false;
        }
    },
    checkTrigger() {
        const options = {
          threshold: 0.1,
        };
        const checker = document.querySelector(".footer");
        const infiniteScroll = (entries) => {
          entries.forEach((entry) => {
              if (entry.isIntersecting) {
                  if (this.dataArray.length != 0) {
                    this.isAjaxLoading = true;
                    setTimeout(() => {
                      this.pageNumber += 1;
                      this.getSearchResult();
                      this.isAjaxLoading = false;
                    }, 500);
                  }
            }
          });
        };

        const observer = new IntersectionObserver(infiniteScroll, options);
        observer.observe(checker);
    },
  },
  beforeMount() {
      let url_string = window.location.href;
      let url = new URL(url_string);
      this.query = url.searchParams.get("q");
      this.lang = url.searchParams.get("culture");
      this.getSearchResult();
  },
  mounted() {
    document.querySelector(".register-page-form__loader").style.display ="none";
    this.checkTrigger();
  },
};
</script>
